export enum ButtonTypeEnum {
    BUTTON = 'button',
    SUBMIT = 'submit',
    RESET = 'reset'
}
